var map = {
	"./AntDesign.ttf": 71770,
	"./Entypo.ttf": 95946,
	"./EvilIcons.ttf": 96647,
	"./Feather.ttf": 7538,
	"./FontAwesome.ttf": 92187,
	"./FontAwesome5_Brands.ttf": 59009,
	"./FontAwesome5_Regular.ttf": 11553,
	"./FontAwesome5_Solid.ttf": 13980,
	"./Fontisto.ttf": 4993,
	"./Foundation.ttf": 31334,
	"./Ionicons.ttf": 10053,
	"./MaterialCommunityIcons.ttf": 53085,
	"./MaterialIcons.ttf": 16728,
	"./Octicons.ttf": 30273,
	"./SimpleLineIcons.ttf": 83977,
	"./Zocial.ttf": 92331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22661;